import { cva, VariantProps } from "class-variance-authority";
import NextLink from "next/link";
import { Children, ComponentPropsWithoutRef, ForwardedRef, forwardRef, isValidElement } from "react";

import { cn } from "@/lib/utils";

export const linkVariants = cva(
  "inline-flex items-center gap-2 text-sm font-medium transition-colors outline-none focus-visible:outline-primary-300",
  {
    variants: {
      color: {
        primary: "link text-primary hover:text-primary-400 active:text-primary-500",
        "white-black": "link text-white hover:text-black",
        "white-primary": "link text-white hover:text-primary-200 active:text-primary-300",
        "gray-primary": "link text-slate-300 hover:text-primary-200 active:text-primary-300",
        black: "link text-black",
        plain: "",
      },
    },
    defaultVariants: {
      color: "primary",
    },
  }
);

export type LinkProps = ComponentPropsWithoutRef<typeof NextLink> & VariantProps<typeof linkVariants>;

function ForwardedLink({ className, color, children, ...props }: LinkProps, ref: ForwardedRef<HTMLAnchorElement>) {
  const elements = Children.toArray(children).map((child, index) => {
    if (isValidElement(child)) {
      return child;
    }

    return <span key={index}>{child}</span>;
  });

  return (
    <NextLink ref={ref} className={cn(linkVariants({ color }), className)} {...props}>
      {elements}
    </NextLink>
  );
}

const Link = forwardRef(ForwardedLink);
export default Link;
